/* GOOGLE */
// export const GOOGLE_CLIENT_ID =
//   process.env.REACT_APP_GOOGLE_CLIENT_ID ||
//   "665390680839-2vkt2v1pim2bgunumm0dkt4oqcn782cj.apps.googleusercontent.com";

/* ENVIRONMENT */
export const ENV_MODE = process.env.REACT_APP_ENV || "qa";

/* API BASE URL */
export const BASE_URL =
  process.env.REACT_APP_BASE_URL || "https://api.dcdial.com/api/";

/* AUTH USER */
export const SIGNUP_USER = process.env.REACT_APP_USER || "damhherrsisz";
export const SIGNUP_PASS =
  process.env.REACT_APP_USER_PASS || "d30dc4fabdd907c3c19878966e7e";

/* CDN */
export const CDN_FQDN =
  process.env.REACT_APP_CDN_FQDN || "static-qa.dcdial.com";

/* API KEY */
export const API_KEY =
  process.env.REACT_APP_API_KEY || "71a629e3685846a9173884a03f8f559a4d3c6510";

/* clusterid */
export const CLUSTERID = process.env.REACT_APP_CLUSTERID || "10217";
